import './index.scss'

/* import Swiper core, modules, and css */
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules'; // import Swiper modules (if needed). Full list available here: https://swiperjs.com/swiper-api#modules
import { toggleSwiperLock } from './../../js/toggleSwiperLock'

/* global fetch */
class LogoSlider {
  constructor(el) {
    this.$el = el
    
    // console.log('LogoSlider::constructor')
  }
  init() {
    // console.log('LogoSlider::init')
    
    this.initSwiper()
  }
  initSwiper() {
    this.swiper = new Swiper(this.$el.querySelector('.oce-logo-slider__swiper'), {
      slidesPerView: 'auto',
      modules: [Navigation, Scrollbar],
      
      navigation: {
        prevEl: '[data-swiper-prev]',
        nextEl: '[data-swiper-next]',
      },
  
      scrollbar: {
        draggable: false,
        hide: false,
        el: '[data-swiper-scrollbar]'
      },
      
      spaceBetween: 9,
      
      breakpoints: {
        992: {
          spaceBetween: 25
        }
      },
      
      on: {
        init: function( swiper ) {
          return toggleSwiperLock(swiper)
        },
        // click: function (swiper) {
        //   swiper.slideTo(this.clickedIndex, 1000)  
        // },
        resize: function( swiper ) {
          return toggleSwiperLock(swiper)
        },
      },
      preventClicks: true,
      slideToClickedSlide: false,
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.oce-logo-slider') ].forEach($block => {
        $block.expandygg = new LogoSlider($block)
    })
}, {capture: false, passive: true, once: true} || false)
